import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

// Services
import { AddProductService } from 'src/app/services/menu-store/add-product/add-product.service';
import { EditShoppingCarService } from 'src/app/services/header/edit-shopping-car/edit-shopping-car.service';
import { SharedService } from 'src/app/services/shared.service';
import { HeaderService } from 'src/app/services/header/header.service';

// Models
import { Product } from 'src/app/models/product';
import { ProductShoppingCar } from 'src/app/models/productShoppingCar';
import { CategoryAditional } from 'src/app/models/categoryAditional';
import { Aditional } from 'src/app/models/aditional';

import toastr from "toastr";

@Component({
    selector: 'app-edit-shopping-car',
    templateUrl: './edit-shopping-car.component.html',
    styleUrls: ['./edit-shopping-car.component.sass'],
    standalone: false
})
export class EditShoppingCarComponent implements OnInit {

  listSubcriptions: Subscription[] = [];

  product: ProductShoppingCar = new ProductShoppingCar();

  amountProducts: number = 1;

  listAditionals: CategoryAditional[] = [];

  updatingProduct: boolean = false;
  gettingProduct: boolean = false;

  showModuleEditProduct: boolean = false;

  productId: number;

  listAditionalsSelected: ProductShoppingCar[] = [];

  observation: string = '';

  showObservation: boolean = false;

  constructor(
    private _addProductService: AddProductService,
    private _editShoppingCarService: EditShoppingCarService,
    private _headerService: HeaderService,
    private _sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.listenerEditProduct();
  }
  
  ngOnDestroy(): void {
    this.listSubcriptions.forEach((sub: Subscription) => { if (sub) sub.unsubscribe(); });
  }

  addAmount(): void {
    this.amountProducts ++;
    this.product.total = this.amountProducts * this.product.price;
    this._sharedService.formatCurrency(this.product.subtotal);
    // this.product.subtotal = this._sharedService.formatCurrency(this.product.subtotal);
  }

  reduceAmount(): void {
    if(this.amountProducts > 1) {
      this.amountProducts --;
      this.product.total = this.amountProducts * this.product.price;
      // this.product.subtotal = this._sharedService.formatCurrency(this.product.subtotal);
    }
  }

  async addProductToShoppingCar() {
    this.updatingProduct = true;
    let listAditionales: {
      product_id: number,
      quantity: number
    }[] = [];
    this.listAditionals.map( c => {
      c.aditionals.map( p => {
        if(p.selected) {
          listAditionales.push({
            product_id: p.id,
            quantity: p.stackValue
          })
        }
      });
    });
    let data = {
      'product_id' : this.product.id,
      'quantity'   : this.amountProducts,
      'additions'  : listAditionales
    };
    let response: any = await this._addProductService.addProductToShoppingCar(data).toPromise().catch((err: any) => this.handleError(err));
    if( response ){
      this.updatingProduct = false;
      // this.closeAddProduct();
    }
  }

  handleError(error: HttpErrorResponse): void {
    if(error.error.message) console.log(error.error.message);
    this.updatingProduct = false;
  }

  async getShoppingCar() {
    this.gettingProduct = true;
    let response: any = await this._editShoppingCarService.getItemsShoppingCar( this.productId.toString() ).toPromise()
    .catch((err: any) => {
      this.gettingProduct = false;
      console.log('Error al obtener items del carrito.');
    });
    if( response && response.data && response.data.item ){
      this.gettingProduct = false;
      this.product = new ProductShoppingCar(response.data.item);
      document.getElementsByClassName('observation')[0].innerHTML = this.product.note;
      this.amountProducts = this.product.quantity;
      this.listAditionalsSelected = new ProductShoppingCar().mapProduct(response.data.additions);
      this.getAditionals();
      console.log(this.listAditionalsSelected);
    }
  }
  
  async getAditionals() {
    this.gettingProduct = true;
    let response: any = await this._addProductService.getAditionals( this.product.productId.toString() ).toPromise()
    .catch((err: any) => {
      this.gettingProduct = false;
      console.log('Error al obtener los adicionales.');
    });
    if( response && response.data && response.data.adicionales && response.data.adicionales.categorias ){
      this.gettingProduct = false;
      this.listAditionals = new CategoryAditional().mapCategory(response.data.adicionales.categorias);
      this.additionalChosen();
      this.messageCategoryByMinMaxValue();
    }
  }

  messageCategoryByMinMaxValue(): void {
    this.listAditionals.forEach((c) => {
      if (c.quantityMin == 1 && c.quantityMax == 1) c.message = 'Esta sección es obligatoria';
      if (c.quantityMin == 0 && c.quantityMax != 0) c.message = `Opcional, max ${c.quantityMax}`;
      if (c.quantityMin == 0 && c.quantityMax == 0) c.message = 'Opcional';
    });
  }

  additionalChosen(): void {
    this.listAditionalsSelected.map( aditionalShoppingCar => {
      this.listAditionals.map( category => {
        category.aditionals.map( a => {
          
          if( a.id == aditionalShoppingCar.productId ){

            category.selected = true;

            this.selectAditional(a);
            
            a.stackValue = aditionalShoppingCar.quantity

            a.selected = true

          }

        })
      });
    });
  }

  // selectAditional(aditional: Aditional, option?: boolean): void {
  //   if( aditional.stackable ){

  //     this.listAditionals.map( c => {
        
  //       if( c.id == aditional.categoryId ){

  //         c.aditionals.map( a => {
            
  //           if( a.id == aditional.id ){

              
  //             if( option ){
                
  //               a.stackValue += 1
                
  //               this.product.total += a.value  
                
  //               a.selected = true

  //             }else{
                
  //               if(a.stackValue == 0) a.selected = false

  //               if(a.stackValue > 0) {
  //                 a.stackValue -= 1
  //                 this.product.total -= a.value
  //               }
                
  //             }
              
  //           }

  //         })

  //       }

  //     })

  //   }else{

  //     this.listAditionals.map( c => {
        
  //       if( c.id == aditional.categoryId ){

  //         c.aditionals.map( a => {
            
  //           if( a.id == aditional.id ){

  //             if(aditional.selected) {
  //               aditional.selected = !aditional.selected
  //               this.product.total -= a.value
  //               a.stackValue = 0
  //             }else{
  //               aditional.selected = !aditional.selected
  //               this.product.total += a.value
  //               a.stackValue = 1
  //             }

  //           }

  //         })

  //       }

  //     })

  //   }
  // }

  selectAditional(aditional: Aditional, option?: boolean): void {
    if( aditional.stackable ){

      this.listAditionals.map( c => {
        
        if( c.id == aditional.categoryId ){

          let numberOfSelectedElements: number = 0;

          c.aditionals.map( a => a.stackValue > 0 ? numberOfSelectedElements += a.stackValue : null );

          c.aditionals.map( a => {
            
            if( a.id == aditional.id ){
              
              if( option ){

                if( numberOfSelectedElements < c.quantityMax ){
                  
                  a.stackValue += 1
                  
                  this.product.subtotal += a.value
                  
                  a.selected = true

                }else toastr.warning(`Solo puedes seleccionar ${c.quantityMax} ${c.name}.`);

              }else{
                
                if(a.stackValue == 0) a.selected = false

                if(a.stackValue > 0) {
                  a.stackValue -= 1
                  this.product.subtotal -= a.value
                }
                
              }
              
            }

          })

        }

      })

    }else{

      this.listAditionals.map( c => {
        
        if( c.id == aditional.categoryId ){

          let numberOfSelectedElements: number = 0;

          c.aditionals.map( a => a.selected ? numberOfSelectedElements += 1 : null );

          c.aditionals.map( a => {
            
            if( a.id == aditional.id ){

              if(aditional.selected) {

                aditional.selected = !aditional.selected
                this.product.subtotal -= a.value
                a.stackValue = 0

              }else{

                if( numberOfSelectedElements < c.quantityMax) {

                  aditional.selected = !aditional.selected
                  this.product.subtotal += a.value
                  a.stackValue = 1

                }else toastr.warning(`Solo puedes seleccionar ${c.quantityMax} ${c.name}.`);

              }
            }

          })

        }

      })

    }
  }

  openObservation(): void {
    this.showObservation = !this.showObservation;
  }

  changeObservation( e: any ): void {
    this.product.note = e.target.value;
    e.target.value = e.target.value.substr(0,150);
  }

  async updateShoppingCar() {

    if(this.validateNumberOfSelectedElements()){
      let listAditionales: {
        product_id: number,
        quantity: number
      }[] = [];
      this.listAditionals.map( c => {
        c.aditionals.map( p => {
          listAditionales.push({
            product_id: p.id,
            quantity: p.stackValue
          })
          // if(p.selected) {
          // }
        });
      });
      let data = {
        id         : this.product.id,
        quantity   : this.amountProducts,
        additions  : listAditionales,
        note       : this.product.note
      };
      console.log(data);
      
      this.updatingProduct = true;
      let response: any = await this._editShoppingCarService.updateShoppingCar( data ).toPromise()
        .catch((err: any) => {
          this.updatingProduct = false;
          console.log('Error al actualizar carrito.');
        });
      if( response ){
        console.log('producto actualizado');
        this.closeEditProduct();
        this._headerService.emmiterShowShoppingCar(false);
        this._headerService.emmiterShowShoppingCar(true);
        this.updatingProduct = false;
      }
    }

  }

  validateNumberOfSelectedElements(): boolean {
    let flag = 0;
    this.listAditionals.map(c => {
      let numberOfSelectedStackbleElements: number = 0;

      c.aditionals.map( a => {

        if(a.stackable){

          a.stackValue > 0 ? numberOfSelectedStackbleElements += a.stackValue : null

        }else{

          a.selected ? numberOfSelectedStackbleElements += 1 : null;
          
        }

      });

      if(numberOfSelectedStackbleElements < c.quantityMin) {

        toastr.warning(`Debes elegir minimo ${c.quantityMin} ${c.name}.`);

        flag ++;

      }

    });
    
    return flag > 0 ? false : true;

  }

  closeEditProduct(): void {
    this.showModuleEditProduct = false;
  }

  listenerEditProduct(): void {
    this.listSubcriptions.push(
      this._editShoppingCarService.getSubjetProductIdSelected().asObservable().subscribe(
        data => {
          // this.product = data;
          this.productId = data;
          this.showModuleEditProduct = true;
          this.showObservation = false;
          this.getShoppingCar();
          this.amountProducts = 1;
        }
      )
    );
  }
}
